import React from 'react';

interface PageHeaderProps {
    title: string;
    subtitle?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({title, subtitle}) => {
    return (
        <div className="my-8">
            <h1 className="text-5xl font-light text-mld-text-primary tracking-tight">{title}</h1>
            {subtitle && <p className="text-xl text-mld-text-secondary mt-2">{subtitle}</p>}
        </div>
    );
};

export default PageHeader;
